import moment from 'moment'
import {decimalHours,rangeFromYearAndMonth} from '../timeConversion'
import api from './api'
import {fetchAllPages,getOldestPost,fetchPost,postEndPoint,deletePost} from './wordpress'


const isLegacy = (post) => {
    return( post.meta.gps_data &&  (typeof post.meta.gps_data.startPosition !== 'undefined' || typeof post.meta.gps_data.endPosition !== 'undefined' ));
}

const decodeMeta = post => {
    return {...post, meta: {...post.meta, gps_data: post.meta.gps_data ? JSON.parse(post.meta.gps_data) : {}}}
}



const convertLegacy = (postObject, gps_data) => {
    const {startPosition,endPosition,crew,total} = gps_data
    const totalHours = total ? decimalHours(total) : 0
    const startDate = startPosition ? (startPosition.utc || startPosition.serial || "").replace(' ', 'T') : null
    const endDate = endPosition ? (endPosition.utc || endPosition.serial || "").replace(' ', 'T') : null
    const gmtDate = postObject.date_gmt+"Z"
    const eventDate = gmtDate.search("1970") === -1 ? gmtDate : startDate || endDate || postObject.date

    const startWaypoint = {
        date: startDate,
        position: startPosition ? startPosition.position : "",
        speed: startPosition ? startPosition.gs : 0,
        track: ""
    }
    const endWaypoint = {
        date: endDate,
        position: endPosition ? endPosition.position : "",
        speed: endPosition ? endPosition.gs : 0,
        track: ""
    } 

    return {
        id: postObject.id,
        date: eventDate,
        totalHours: totalHours.toString(),
        waypoints: [startWaypoint,endWaypoint],
        assigneeIds: typeof crew === 'object' ? Object.keys(crew).map( id => id ) : []
    };
}

const metaObject = (postObject) => {
    
    const {gps_data} = postObject.meta
    if(isLegacy(postObject)){
        const convertedObject = convertLegacy(postObject, gps_data)
        convertedObject.modified_gmt = postObject.modified_gmt
        return convertedObject;
        
    }else if(gps_data.waypoints){
        gps_data.modified_gmt = gps_data.client_created_gmt ? gps_data.client_created_gmt : postObject.modified_gmt
        gps_data.id = postObject.id
        delete gps_data.client_created_gmt
        return gps_data;
    }
  
    return postObject;
}



export const saveEvent = async (id,updatedData) => {
    if( typeof id === 'undefined' || typeof updatedData === 'undefined' ){
        console.log("Log post id or data missing.")
    }
    if(id !== 0){
        const existingPost = await fetchPost(id,"is_log_time")
        const decodedPost = decodeMeta(existingPost)
        const gpsDataMeta = metaObject(decodedPost)
        const updatedMeta = {...gpsDataMeta,...updatedData}
        const encodedMeta = JSON.stringify(updatedMeta)
        const savedEvent = await postEndPoint(`is_log_time/${id}`,{meta: {...existingPost.meta, gps_data: encodedMeta}})
  
        return formatEvent(decodeMeta(savedEvent));
    }else{
        updatedData.client_created_gmt = moment().utc().format('YYYY-MM-DDTHH:mm:ss')
        const encodedMeta = JSON.stringify(updatedData)
        const newPost = {
                date_gmt: updatedData.date.substring(0,19),
                title: `${api.productId} - ${updatedData.date} - ${updatedData.totalHours}`, // DO NOT CHANGE! Required to enable the backend to block duplicates. Backend will reject posts with no title.
                status: 'publish',
                meta: {
                    trackable_product_id: api.productId, 
                    gps_data: encodedMeta,
                }
            }
        const savedEvent = await postEndPoint(`is_log_time`, newPost)
   
        return  formatEvent(decodeMeta(savedEvent));
    }
    
}

export const deleteEvent = async (id) => {
    if( id === 0 || typeof id === 'undefined' ){
        // eslint-disable-next-line
        throw {message: "Trying to delete non-existent event.", code: "invalid-delete", data: {}}
    }

    return await deletePost(id,'is_log_time');
}

const fetchLogPosts = async (afterDate,beforeDate,onPageLoad) => {

    let fetchString = `is_log_time?after=${encodeURIComponent(afterDate)}&before=${encodeURIComponent(beforeDate)}`
    if(api.productId){
        fetchString = `${fetchString}&meta_key=trackable_product_id&meta_value=${encodeURIComponent(api.productId)}`
    }

    const allPosts = await fetchAllPages(fetchString,(posts) => {
        const metaMappedObjects = posts.map( decodeMeta )
        onPageLoad(metaMappedObjects.map(formatEvent))
    });

    return allPosts.map( decodeMeta ).map( formatEvent );
}


const formatEvent = (event) => {
    return typeof event.meta === 'object' ? metaObject(event) : {};
}

export const gapRanges = (range,events) => {

    if(!events) return([range]);

    const sortedEvents = events.filter( ({waypoints}) => waypoints[0].date && waypoints[waypoints.length-1].date ).sort( (a,b) => {
        if( moment(a.date).isBefore(b.date) ) return(-1);
        if( moment(a.date).isSame(b.date) ) return(0);
        return(1); 
    })

    const gaps = sortedEvents.reduce( (ranges, {waypoints}) => {

        if(waypoints.length>1){
            const start = waypoints[0].date
            const end = waypoints.slice(-1)[0].date
            if(start && end){
                const lastRange = ranges.slice(-1)[0]
                lastRange.end = start
                const newRanges = ranges.slice(0,-1)
                newRanges.push(lastRange)
                newRanges.push({start: end})
                return newRanges;
            }
        }
        return ranges;

    },[{...range}])
    gaps[gaps.length-1].end = range.end

    return gaps;
}

export const getEvents = async (year,month,updateEvents = () => {}) => {

    if(isNaN(parseInt(year))) throw new Error("Unkown year provided.");
    if(month !== "All" && isNaN(parseInt(month))) throw new Error("Unkown month provided.");

    const {start,end} = rangeFromYearAndMonth(year,month)

    return await fetchLogPosts( start, end, updateEvents );
}



export const getOldestEvent = async () => {
    return await getOldestPost( "is_log_time" );
}
